
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, BookOpen, GraduationCap } from 'lucide-react';
import { BRAND_NAME } from '../constants';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="bg-blue-600 p-2 rounded-lg">
                <GraduationCap className="h-8 w-8 text-white" />
              </div>
              <span className="text-2xl font-bold text-slate-900 tracking-tight">{BRAND_NAME}<span className="text-blue-600">.pk</span></span>
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-slate-600 hover:text-blue-600 font-medium transition">Home</Link>
            <Link to="/notes-hub" className="text-slate-600 hover:text-blue-600 font-medium transition">Notes Hub</Link>
            <div className="relative group">
              <button className="text-slate-600 hover:text-blue-600 font-medium transition inline-flex items-center">
                Classes
                <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
              </button>
              <div className="absolute hidden group-hover:block w-48 bg-white shadow-xl border border-gray-100 rounded-xl py-2 mt-0">
                <Link to="/class/class-9" className="block px-4 py-2 text-sm text-slate-700 hover:bg-blue-50 hover:text-blue-600">Class 9</Link>
                <Link to="/class/class-10" className="block px-4 py-2 text-sm text-slate-700 hover:bg-blue-50 hover:text-blue-600">Class 10</Link>
                <Link to="/class/class-11" className="block px-4 py-2 text-sm text-slate-700 hover:bg-blue-50 hover:text-blue-600">1st Year</Link>
                <Link to="/class/class-12" className="block px-4 py-2 text-sm text-slate-700 hover:bg-blue-50 hover:text-blue-600">2nd Year</Link>
              </div>
            </div>
            <Link to="/exam-prep" className="text-slate-600 hover:text-blue-600 font-medium transition">Exam Prep</Link>
            <Link to="/about" className="text-slate-600 hover:text-blue-600 font-medium transition">About</Link>
            <Link to="/contact" className="bg-blue-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-blue-700 transition shadow-md">Contact Us</Link>
          </div>

          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-600 hover:text-blue-600 focus:outline-none">
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 py-4 px-4 space-y-2 animate-in slide-in-from-top duration-300">
          <Link to="/" className="block px-4 py-2 text-slate-700 hover:bg-blue-50 rounded-lg">Home</Link>
          <Link to="/notes-hub" className="block px-4 py-2 text-slate-700 hover:bg-blue-50 rounded-lg">Notes Hub</Link>
          <Link to="/class/class-9" className="block px-4 py-2 text-slate-700 hover:bg-blue-50 rounded-lg">Class 9</Link>
          <Link to="/class/class-10" className="block px-4 py-2 text-slate-700 hover:bg-blue-50 rounded-lg">Class 10</Link>
          <Link to="/class/class-11" className="block px-4 py-2 text-slate-700 hover:bg-blue-50 rounded-lg">1st Year</Link>
          <Link to="/class/class-12" className="block px-4 py-2 text-slate-700 hover:bg-blue-50 rounded-lg">2nd Year</Link>
          <Link to="/exam-prep" className="block px-4 py-2 text-slate-700 hover:bg-blue-50 rounded-lg">Exam Prep</Link>
          <Link to="/contact" className="block px-4 py-2 text-white bg-blue-600 rounded-lg text-center font-bold">Contact Us</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
